export class ReciboPago {
    RECEIPT_PAYMENT_ID: number;
    RECEIPT_PAYMENT_NUMBER: string;
    CUSTOMER_ID: number;
    CUSTOMER_NAME: string;
    CUSTOMER_RFC: string;
    ORGANIZATION_ID: number;
    TAX_REGIME_ID: number;
    NOMBRE_EMISOR: string;
    CALLE_EMISOR: string;
    COLONIA_EMISOR: string;
    CIUDAD_EMISOR: string;
    ESTADO_EMISOR: string;
    CODIGOPOSTAL_EMISOR: string;
    TELEFONO_EMISOR: string;
    CORREO_EMISOR: string;
    CALLE_RECEPTOR: string;
    COLONIA_RECEPTOR: string;
    CIUDAD_RECEPTOR: string;
    ESTADO_RECEPTOR: string;
    CODIGOPOSTAL_RECEPTOR: string;
    BILL_STATUS_ID: number;
    FECHA_PAGO: string;
    PAYMENT_DATE: string;
}

export class ReciboPagoDetalle {
    RECEIPT_PAYMENT_DETAIL_ID: number;
    RECEIPT_PAYMENT_ID: number;
    COIN_SAT_ID: number;
    RECEIVER_PAYMENT_FORM_ID: number;
    AMOUNT: string;
    PAYMENT_DATE: string;
    EXCHANGE_RATE: number;
    RFC_ORIGINATOR_ACCOUNT: string;
    ORIGINATOR_ACCOUNT: string;
    RFC_BENEFICIARY_ACCOUNT: string;
    BENEFICIARY_ACCOUNT: string;
    ORIGINATOR_BACK_ACCOUNT_ID: number;
    BENEFICIARY_BACK_ACCOUNT_ID: number;
    NUM_OPERATION: string;
    COMMENTS: string;
    FECHA_PAGO: string;
}

export class ReciboPagoDocumento {
    DOCTOS_RELATED_RECEIPT_PAYMENT_ID: number;
    RECEIPT_PAYMENT_DETAIL_ID: number;
    DOCUMENT_ID: string;
    BILL_ID: number;
    DOCUMENT_NUMBER: string;
    COIN_SAT_ID: number;
    EXCHANGE_RATE: number;
    RECEIVER_PAYMENT_METHOD_ID: number;
    PARTIALITY_NUMBER: number;
    PREVIOUS_BALANCE_AMOUNT: number;
    PAID_AMOUNT: number;
    UNPAID_BALANCE_AMOUNT: number;
    index: number;
    isChecked: boolean;
    CURRENCY: string;
    CONDICIONAL: string;
    LAST_PAID_AMOUNT: number;
    UUID: string;
    IVA_FACTOR: number;
    IVA_AMOUNT: number;
    SUBTOTAL_BEFORE_TAX: number;
     
}



// WEBPACK FOOTER //
// ./src/app/models/ReciboPago.ts